/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {

    /** ----------------------------------------
         Get Template
     ---------------------------------------- */

    getTemplate: state => name => {
        const findTemplate = obj => obj.template === name;
        const template = state.data.find(findTemplate);
        return template.content;
    }

};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters